export interface IChatInboxPostMessage {
  origin: string;
  type: ChatInboxMessageTypes;
  id?: string;
  payload: IChatInboxGeneralPayload | IChatInboxMessagePayload;
}

export interface IChatInboxMessagePayload {
  data: {
    messagedBy: string;
    data: string;
    uuid: string;
    _bot: string;
    notificationType: NotificationTypes;
  }
  message: string;
  title: string;
}



export interface IChatInboxGeneralPayload {
  data: {
    message: string;
  };
  message: string;
  title: string;
}

export enum ChatInboxMessageTypes {
  MESSAGE = 'message',
  LEAD = 'lead',
  LIVE_CHAT_REQUEST = 'live-chat-request'
}

export enum NotificationTypes {
  NEW_MESSAGE = 'NEW_MESSAGE'
}
